import { render } from "./ExtendedWarrantyForFigPlan.vue?vue&type=template&id=5c71878f&scoped=true&ts=true"
import script from "./ExtendedWarrantyForFigPlan.vue?vue&type=script&lang=ts"
export * from "./ExtendedWarrantyForFigPlan.vue?vue&type=script&lang=ts"

import "./ExtendedWarrantyForFigPlan.vue?vue&type=style&index=0&id=5c71878f&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c71878f"]])

export default __exports__